__turbopack_context__.v({
  "accordion-trigger": "calculator-layout-trigger-module-scss-module__9Wlxja__accordion-trigger",
  "chip": "calculator-layout-trigger-module-scss-module__9Wlxja__chip",
  "placeholder": "calculator-layout-trigger-module-scss-module__9Wlxja__placeholder",
  "radio-button": "calculator-layout-trigger-module-scss-module__9Wlxja__radio-button",
});
